export default {
    unauthorized: 401
}